export default __webpack_public_path__ + "static/media/white_product_icon.3c455629.svg";